import { Component, OnInit } from '@angular/core';
import {RoutesConst} from '@carm/shared/constants/const-routes';
import { last, takeUntil } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { DashboardCountService } from '@carm/_core/dashboard-count/services/dashboard-count.service';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { BaseComponent } from '@carm/_utils/base.component';
import { minStartDate } from '@carm/shared/constants/const-carm';

@Component({
  selector: 'carm-appeals',
  templateUrl: './appeals.component.html',
  styleUrls: ['./appeals.component.scss']
})
export class AppealsComponent extends BaseComponent implements OnInit {

  viewAllAppealsUrl: string;
  ongoingAppealRequests: number;
  loading = true;

  constructor(private dashboardCountService: DashboardCountService, private carmRouter: CarmRouter) {
    super();
  }

  ngOnInit(): void {
    this.viewAllAppealsUrl = RoutesConst.Appeals_List;

    const minDate = minStartDate;
    const today = new Date();

    combineLatest([
      this.carmRouter.bn9$,
      this.carmRouter.bn15$,
    ])
    .pipe(takeUntil(this.destroy$))
    .subscribe(([bn9, programId]) => {

      this.loading = true;

        this.dashboardCountService.getAppealsCount(bn9, programId, minDate, today)
        .pipe(takeUntil(this.destroy$), last())
        .subscribe(getAppealsResponse =>
        {
          this.loading = false;
          this.ongoingAppealRequests = getAppealsResponse?.recordCount || 0;
        },
        () => this.loading = false
      );
    }, () => this.loading = false);
  }
}



